import axios, { AxiosInstance } from 'axios'

const client: AxiosInstance = axios.create({
  baseURL: process.env.GATSBY_EMBONOR_DISTRIBUTION_CENTER_SERVICE_HOST,
})

export default client
